import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import Avatar from "../avatar";
// import md5 from "js-md5";
import classNames from "classnames";
import MenuItemDecorator from "../menu-item-decorator";

import { merge, $ } from "glamor";
import { DATATEST } from "constants/integration";

let styles;
const getStyles = () => {
    if (!styles) {
        styles = merge(
            {
                display: "block",
                position: "relative",
                textAlign: "left",
                color: "rgba(255,255,255,.8)",
                transition: "all .15s ease-in-out",
                padding: "8px",
                overflow: "hidden",
                lineHeight: "14px",
                height: "60px",
                cursor: "pointer",
            },
            $(":hover", {
                background: "rgba(153,153,153,.12)",
                color: "white",
            }),
            $(".hover", {
                background: "rgba(153,153,153,.12)",
                color: "white",
            }),
            $(" > .avatar", {
                position: "absolute",
                top: "8px",
                left: "8px",
            }),
            $(" > .label", {
                fontSize: "14px",
                minWidth: "160px",
                padding: "0px",
                margin: "0px",
                marginLeft: "54px",
            }),
            $(" .name", {
                paddingTop: "2px",
                fontSize: "16px",
                fontWeight: "bold",
                lineHeight: "24px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            }),
            $(" .email", {
                fontSize: "11px",
                fontWeight: 200,
                lineHeight: "12px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            })
        );
    }
    return styles;
};

@MenuItemDecorator
class Settings extends PureComponent {
    static propTypes = {
        style: PropTypes.object,
        me: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {};
    }

    UNSAFE_componentWillMount() {
        this.generateUserData();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.me.email !== this.props.email) {
            this.generateUserData(nextProps);
        }
    }

    generateUserData(props = this.props) {
        this.setState({
            emailHash: props.me.email_hash || "",
            initials: props.me._initials,
            name: props.me.name,
        });
    }

    render() {
        const { me, to } = this.props;
        const { emailHash, initials, hover } = this.state;

        return (
            <a {...getStyles()} className={classNames({ hover })} href={to} data-test={DATATEST.NAV.PROFILE_MENU}>
                <Avatar
                    src={`https://secure.gravatar.com/avatar/${emailHash}?s=88&d=blank`}
                    label={initials}
                    width={44}
                    shape="circle"
                />
                <div className="label">
                    <div className="name">{me.name}</div>
                    <div className="email">{me.email}</div>
                </div>
            </a>
        );
    }
}

export default Settings;
